import { FETCH_STORES_SUCCESS } from './types'; // Fired when the store info API returns a list of stores with stock info

export var storeLoaded = function storeLoaded(stores) {
  return {
    type: FETCH_STORES_SUCCESS,
    payload: stores
  };
};
export default storeLoaded;